import React, {FC, useState, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {InputTextWrapper, SelectWrapper} from '../../../../../../components/UI/Form/Input'
import {ParamsModel, MasterModel, CategoryModel} from '../../../../model'
import {
  getParamsById,
  getCategory,
  getDataType,
  getParams,
  getMasterService,
} from '../../../../services'
import {useCentral} from '../../../../../../hooks/useCentral'
import {TITLE_FORM_PARAMS} from '../../../../util/Constants'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {initValues} from '../../../../util/values/params'

const Params: FC = () => {
  const {setValue} = useFormContext()
  const {currentTabItem} = useCentral()
  const [category, setCategory] = useState<MasterModel[] | any>([])
  const [status, setStatus] = useState<MasterModel[] | any>([])
  const [params, setParams] = useState<MasterModel[] | any>([])
  const [dataType, setDataType] = useState<MasterModel[] | any>([])

  const getCategoryList = async () => {
    try {
      let obj: CategoryModel = {
        isCombo: true,
      }
      const response = await getCategory(obj, 1)
      const data = response.data.data
      const mappedSites = data.map((item) => ({
        value: item.codigo || '',
        label: item.nombre || '',
      }))
      mappedSites.unshift({
        value: '',
        label: 'Selecciona una opción',
      })
      setCategory(mappedSites)
    } catch (error) {
      console.error('Error al obtener la lista de países:', error)
    }
  }
  const getParamsList = async (name: string = '') => {
    try {
      let obj: ParamsModel = {
        isCombo: true,
      }
      const response = await getParams(obj, 1, name)
      const data = response.data.data
      const mappedSites = data.map((item) => ({
        value: item.codigo || '',
        label: item.nombreCorto || '',
      }))

      setParams(mappedSites)
    } catch (error) {
      console.error('Error al obtener la lista de países:', error)
    }
  }
  const getStatusList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoMaestro',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
        codigo: master.codigo,
      }))
      setStatus(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de estado del maestro:', error)
    }
  }
  const getDataTypeList = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000))
      const response = await getDataType()
      const data = response.data.data
      const mappedSites = data.map((item) => ({
        value: item.id || '',
        label: item.nombre || '',
      }))

      setDataType(mappedSites)
    } catch (error) {
      console.error('Error al obtener la lista de países:', error)
    }
  }
  const getParamsByIdValues = async () => {
    const response = await getParamsById(currentTabItem.idToEdit)
    const data = response.data.data
    type ParamsModelKeys = keyof ParamsModel

    for (const fieldName in initValues) {
      if (initValues.hasOwnProperty(fieldName)) {
        if (data.hasOwnProperty(fieldName)) {
          if (data[fieldName as ParamsModelKeys]) {
            setValue(fieldName, data[fieldName as ParamsModelKeys])
          } else {
            setValue(fieldName, '')
          }
        }
      }
    }
  }
  useEffect(() => {
    getDataTypeList()
    getCategoryList()
    getStatusList()
  }, [])
  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getParamsByIdValues()
    }
  }, [currentTabItem.idToEdit])

  const handleChangeParams = (e: any) => {
    let value = e ? e : ''

    setValue('tablaPadre', value.value)
    setParams([])
    if (value.value) getParamsList(value.value)
  }

  let isDisabled = currentTabItem.idToEdit ? true : false

  return (
    <ContentForm isEdit={isDisabled} title={TITLE_FORM_PARAMS}>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Categoría' name='tabla' data={category} required />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            type='alphaNumeric'
            labelText='Código'
            name='codigo'
            textPlaceholder='Escribe el código'
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            type='alphaNumeric'
            labelText='Nombre corto'
            name='nombreCorto'
            textPlaceholder='Escribe el nombre'
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            type='alphaNumeric'
            labelText='Nombre largo'
            name='nombreLargo'
            textPlaceholder='Escribe el nombre'
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Tipo de dato' name='tipoDato' data={dataType} required />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Activo' name='estado' data={status} required />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Categoría padre'
            name='tablaPadre'
            data={category}
            onChangeValue={handleChangeParams}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Parámetro padre' name='codigoPadre' data={params} />
        </div>
      </div>
    </ContentForm>
  )
}

export default Params
